import { fonts } from '@ui/kit/design-tokens';
import { combineTokens } from '@utils/css';

combineTokens("--font-radio", {
  font: fonts.proxima
});
const wrapper = "_275wut3auu";
const labelWrapper = "_275lyu15ds";
const teaser = "_275tuy6ii6";

export { labelWrapper, teaser, wrapper };
import "./atom.font-radio.style.linaria.module.css";
//# sourceMappingURL=atom.font-radio.style.js.map
